import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, MagnifyingGlass } from "@phosphor-icons/react";
import { lookupPostcode } from "@/lib/postcodes";
import { HALLS, slug } from "@/lib/areas";

// Slim postcode lookup bar — designed to sit at the very top of every public
// page so visitors can quickly find their nearest training options.
export default function PostcodeLookupBar() {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    setErr("");
    const r = lookupPostcode(code);
    if (!r) {
      setErr(`We don't have ${code} on our common list — email the team to confirm.`);
      return;
    }
    // Navigate to the first suburb in that postcode, which surfaces the
    // service summary + closest hall for that region.
    const first = (r.suburbs && r.suburbs[0]) || HALLS[r.hall]?.name;
    navigate(`/service-areas/${slug(first)}`);
  };

  return (
    <div className="bg-[#1b4a76] text-white" data-testid="postcode-bar">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-2.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
        <div className="flex items-center gap-2 text-[#E2B054] flex-shrink-0">
          <MapPin size={16} weight="duotone" />
          <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider">Find your local training options</span>
        </div>
        <form onSubmit={submit} className="flex items-stretch gap-2 flex-1 max-w-sm">
          <input
            data-testid="postcode-bar-input"
            type="text"
            inputMode="numeric"
            pattern="[0-9]{4}"
            maxLength={4}
            value={code}
            onChange={(e) => { setCode(e.target.value.replace(/[^0-9]/g, "")); setErr(""); }}
            placeholder="Enter postcode (e.g. 4575)"
            className="flex-1 rounded-md px-3 py-1.5 bg-white text-stone-900 placeholder-stone-400 text-sm focus:outline-none focus:ring-2 focus:ring-[#f38838]/50"
            aria-label="Postcode"
          />
          <button
            data-testid="postcode-bar-submit"
            type="submit"
            disabled={code.length !== 4}
            className="bg-[#f38838] hover:bg-[#e07a2f] disabled:opacity-50 px-3 py-1.5 rounded-md text-sm font-semibold inline-flex items-center gap-1.5 transition-colors"
          >
            <MagnifyingGlass size={14} weight="bold" /> Go
          </button>
        </form>
        {err && <span className="text-xs text-[#FDD9B0]" data-testid="postcode-bar-error">{err}</span>}
      </div>
    </div>
  );
}
